import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import SectionTitle from '~/components/Account/Logged/SectionTitle'
import RichText, { RichTextBlock } from '~/components/UI/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type ReturnsProps = {
  className?: string
  title?: RichTextBlock
  text?: RichTextBlock
}

function Returns({ className, title, text }: ReturnsProps) {
  const textStyle = useStyle({
    textPreset: GlobalTextPreset.Text14GroteskRegular,
    color: GlobalThemeColors.Black,
  })

  return (
    <div className={cx(className, css.Returns)}>
      <SectionTitle className={css.title} title={title} />
      <RichText className={textStyle} render={text} />
    </div>
  )
}

Returns.defaultProps = {}

export default Returns
